import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import LockIt from './components/LockIt';
import Monely from './components/Monely';
import MotionDesign from './components/MotionDesign';
import Contact from './components/Contact';
import Navigation from './components/Navigation';

function App() {
  const [currentSection, setCurrentSection] = useState(0);
  const [scrollProgress, setScrollProgress] = useState(0);
  const sectionsRef = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      const progress = (scrollPosition / (documentHeight - windowHeight)) * 100;
      setScrollProgress(progress);

      const sectionIndex = Math.floor(scrollPosition / windowHeight);
      setCurrentSection(Math.min(sectionIndex, 6));
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Navigation currentSection={currentSection} />
      <div className="scroll-progress" style={{ width: `${scrollProgress}%` }} />
      
      <Hero ref={el => sectionsRef.current[0] = el} />
      <About ref={el => sectionsRef.current[1] = el} />
      <Skills ref={el => sectionsRef.current[2] = el} />
      <LockIt ref={el => sectionsRef.current[3] = el} />
      <Monely ref={el => sectionsRef.current[4] = el} />
      <MotionDesign ref={el => sectionsRef.current[5] = el} />
      <Contact ref={el => sectionsRef.current[6] = el} />
    </div>
  );
}

export default App;
